export default "__VITE_ASSET__Q8_kUg9g__"